export const config = {
  correctPassword:
    "$2a$10$e9Y3bY7XqDjUl12Uwff87e28tugXp6VEZyUmLbnQO7T9kdC9B8yvi", // Set the password here
  BackendUrl: "https://shay-fp2k.onrender.com",
  //BackendUrl: "http://localhost:5001",
};
